import * as React from "react";
import { Typography, Box, Card, useTheme } from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { useNavigate } from "react-router";
import moment from "moment/moment";

import AvatarList from "../../../../AvatarList";
import RightLeftChecker from "../../../../../../utils/RightLeftChecker";
import CustomAvatar from "../../../../CustomAvatar";
import CustomCircleButton from "../../../../CustomCircleButton";

const TableDetailCart = ({ rowData }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Card
      onClick={() => navigate(`/table/${rowData.pk}`)}
      sx={{
        padding: "16px 16px 8px 16px",
        border: "2px solid",
        borderColor: "black.main",
        boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
        borderRadius: "16px",
        // maxHeight: "156px",
        marginBottom: "24px",
        cursor: "pointer",
      }}
    >
      <Box sx={{ overflow: "hidden", display: "flex", py: "2px" }}>
        <Box sx={{ pb: "4px" }}>
          <CustomAvatar size={64} round={"8px"} src={rowData.banner} />
        </Box>
        <Box
          sx={{
            width: "72%",
            display: "flex",
            flexDirection: "column",
            ml: "8px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Tahrir",
              fontWeight: "700",
              lineHeight: "24px",
              fontSize: "24px",
              width: "100%",
              color: "black.main",
              textAlign: RightLeftChecker(rowData.title) ? "right" : "left",
              direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
              px: "4px",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {rowData.title}
          </Typography>
          <Box
            sx={{
              mt: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "end",
            }}
          >
            <Typography sx={{ color: "mute.main", fontSize: "11px" }}>
              {rowData.category.name}
            </Typography>
            <Typography sx={{ color: "mute.main", fontSize: "11px" }}>
              Started at {moment(rowData.created_at).format("DD/MM/YYYY")}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          borderTop: "2px solid",
          borderColor: "black.main",
          marginTop: "8px",
          paddingTop: "8px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <AvatarList type='table' avatarData={rowData} size={35} />

          <Box sx={{ width: "24px", height: "24px", textAlign: "right" }}>
            <CustomCircleButton
              width='22px'
              height='22px'
              bgColor='primary.main'
              hoverBgColor='primary.main'
              hoverColor='black.main'
              hoverBorder={`none`}
              bShadow={`0px 2px 0px ${theme.palette.black.main}`}
              activeBgColor='black.main'
              activeColor='white.main'
            >
              <KeyboardArrowRightRoundedIcon sx={{ pl: "2px", fontSize: 20 }} />
            </CustomCircleButton>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
export default TableDetailCart;
